import { useState, useEffect, useContext } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import "../components/button.css";
import Alerts from "../components/Alerts";
import { TextField, FormControl } from "@mui/material";
import { marginBottom, marginTop } from "../App";
import Button from "@mui/material/Button";
import { fetchUserData } from "../components/auth";
import { apiRequest } from "../components/Config";
import { Card } from "@mui/material";

const Login = ({ hideFooter }) => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [apiResponse, setApiResponse] = useState({});
  const navigate = useNavigate();
  const { userData, setUserData } = useContext(UserDataContext);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [sent, setSent] = useState(false);

  const ClearApiResponse = () => {
    setShowApiResponse(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await apiRequest("login", "POST", {
        user: user,
        password: password,
      });

      setUserData(response);

      const id = response.userId;

      if (response.userId) {
        navigate("/filesgallery");
        return;
      }

      if (response.error_msg === 403) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Brak uprawnień lub niewłaściwe hasło!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 501) {
        setApiResponse({
          title: "Błąd",
          severity: "error",
          info: "Konto nieaktywne, zablokowane lub nie istnieje!",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 502) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano nazwy użytkownika.",
        });
        setShowApiResponse(true);
      }
      if (response.error_msg === 503) {
        setApiResponse({
          title: "Ostrzeżenie",
          severity: "warning",
          info: "Nie podano hasła.",
        });
        setShowApiResponse(true);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Błąd podczas wysyłania danych.",
      });
      setShowApiResponse(true);
      //navigate("/nopermission");
    }
  };

  useEffect(() => {
    hideFooter(true);
    return () => hideFooter(false);
  }, [hideFooter]);

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const userDataAnswer = await fetchUserData();
        if (userDataAnswer && userDataAnswer.userId) {
          setUserData(userDataAnswer);
          navigate("/filesgallery");
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.error("Error during user verification:", error);
        navigate("/login");
      } finally {
        // setLoading(false);
      }
    };
    verifyUser();
  }, [navigate, userData]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event);
    }
  };
  return (
    <>
      {showApiResponse && (
        <Row style={{ marginTop }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      <Container style={{ paddingTop: "100px" }}>
        <Row style={{ marginBottom }}>
          <Col>
            <Form onKeyDown={handleKeyDown} autoComplete="off">
              <Row
                style={{
                  marginBottom,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Col xs="auto">
                  <FormControl>
                    <TextField
                      autoComplete="none"
                      label="Konto"
                      type="text"
                      variant="standard"
                      value={user || ""}
                      onChange={(e) => {
                        setUser(e.target.value);
                        ClearApiResponse();
                      }}
                      style={{ width: "130px" }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </FormControl>
                </Col>

                <Col xs="auto">
                  <FormControl>
                    <TextField
                      label="Hasło"
                      type="password"
                      variant="standard"
                      value={password || ""}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        ClearApiResponse();
                      }}
                      style={{ width: "130px" }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </FormControl>
                </Col>
              </Row>
              <Row>
                <Col xs="auto">
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={handleSubmit}
                    style={{ minWidth: "88px" }}
                  >
                    Zaloguj
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Login;
